<template>
  <div>
  <div class="detail">
    <h4 class="item-h4">{{detailList.title}}</h4>
    <div class="date">发布时间：{{detailList.createTime}}
      <span style="margin-left: 10px;" v-if="detailList.source !== null">来源: {{detailList.source}}</span></div>
<!--    视频-->
    <div class="video-box" v-show="this.formName == 'video' && detailList.pictureVideoFileList">
      <div id="playbox" class="playbox">
        <div id="videobox" class="videobox" v-for="item in detailList.pictureVideoFileList">
<!--              @ready="playReadied"-->
          <video-player
              :poster="posterPic"
              class="video-player vjs-custom-skin"
              :playsinline="true"
              style="object-fit:cover;"
              :options="`/admin/sys-file/getFileInfo${item.url}` | videoOption">
<!--              :options="playerOptions">-->
          </video-player>
         <!-- <video
              id="my-video"
              class="video-js vjs-default-skin"
              controls
              preload="auto"
              width="640"
              height="264"
              :poster="posterPic"
              data-setup="{}" >
            <source :src="item.url" type="application/x-mpegURL"/>
            <p class="vjs-no-js">
              To view this video please enable JavaScript, and consider upgrading to a
              web browser that
              <a href="https://videojs.com/html5-video-support/" target="_blank"
              >supports HTML5 video</a
              >
            </p>
          </video>-->
        </div>
      </div>
      <!--      <div class="file" style="position: relative">-->
      <!--        <div style="position: relative;width:600px;margin: 0 auto;" >-->
      <!--          <div >-->
      <!--          <video v-for="(file,fileIndex) in detailList.pictureVideoFileList" :key="fileIndex"-->
      <!--                 id="video" @loadedmetadata="createPreImg($event)"-->
      <!--                 style="object-fit: contain;width: 100%;height: 450px;padding-bottom: 10px;"-->
      <!--                 :controls="true" >-->
      <!--            <source :src="file.url"/>-->
      <!--          </video>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--        </div>-->
    </div>
<!--    内容-->
    <div class="ql-container" v-if="formName !== 'picture'">
    <p class=" pre ql-snow ql-editor content-detail  content" v-html="detailList.content">
    </p>
    </div>
    <div v-if="formName === 'picture'">
      <div v-if="swiperList.length >0"  class="detail-picture">
<!--        第三版本瀑布流布局-->
        <div class="waterfall-container">
          <div class="waterfall">
<!--            <my-waterfall :data="selectedImage"></my-waterfall>-->
            <waterfall :col="col" :data="selectedImage">
              <template>
                <div class="cell-item" v-for="(item, index) in selectedImage" :key="index" @click="imgClick(item)">
                  <img :src="item.url" alt="加载错误" />
                  <div class="item-body">
                    <div class="item-desc">{{ item.content }}</div>
                    <div class="item-footer">
                      <div class="footer-left">
                        <span class="time">{{item.shootTime}}</span>
                        <div class="name">{{ item.shootPlace }} </div>
                      </div>
                      <div class="like">
                        <div class="like-total">{{ item.shootUser }} 摄</div>
                      </div>
                    </div>
                  </div>
                </div>

<!--                <div style="height: 100%;">-->
                <!--
                <el-dialog fullscreen :visible.sync="dialogVisibleImg" width="100%"  center style="z-index: 9999 !important;height: 100%;"  close-on-click-modal :modal="false" >
                  <div  class="image-preview" style="height: 100%;" v-if="currentImage">
                    <div >
                      <div @click="prevImage" style="position: fixed;left: 5%; top: 50vh;width: 40px;height: 40px; border-radius: 50%;background-color: rgba(0,0,0,0.2);">
                        <i style="font-size: 18px;color: #fff;position:fixed;left: 5%; top: 50vh;cursor: pointer;margin-left: 9px;line-height: 40px" class="el-icon-arrow-left"></i>
                      </div>
                      <div style="" class="preview-image">
                        <img  :src="currentImage" id="image"/>
                        <div class="preview-text" >
                          <div style="color: white">{{ currentContent }}</div>
                          <div style="color: white">{{ currentUser }} 摄</div>
                        </div>
                        <div class="preview-text-bottom" >
                          <span>{{ currentTime }}</span>
                          <span style="margin-left: 16px;">{{ currentPlace }}</span>
                        </div>
                        <div style="position: fixed;margin-left: 50%;  transform: translate(-50%,0%); text-align: center;width: 350px;height: 40px;border-radius: 20px;background-color: rgba(255,255,255,.2);">
                          <span class="el-icon-plus"  style="margin: 0 20px;color: white;line-height: 40px" @click="zoomIn"></span>
                          <span class="el-icon-minus"  style="margin: 0 20px;color: white;line-height: 40px" @click="zoomOut"></span>
                          <span class="el-icon-full-screen"  style="margin: 0 20px;color: white;line-height: 40px" @click="fullScreenClick"></span>
                        </div>
                      </div>
                      <div @click="nextImage" style="position: fixed;right: 5%; top: 50vh;width: 40px;height: 40px; border-radius: 50%;background-color: rgba(0,0,0,0.2);">
                        <i style="font-size: 18px;color: #fff;position:fixed;right: 5%; top: 50vh;line-height: 40px;margin-right: 8px;cursor: pointer" class="el-icon-arrow-right"></i>
                      </div>
                    </div>
                    <div class="thumbnail-list">
                      <img v-for="(img, index) in selectedImage" :key="index" :src="img.url" alt="" @click="imageClick2(img.url,index)" />
                    </div>
                  </div>
                </el-dialog>
                -->
<!--                </div>-->
              </template>
            </waterfall>
          </div>
        </div>
        <!-- 第二版本修改
        <el-carousel>
          <el-carousel-item v-for="item in swiperList" :key="item.id">
            <div class="detail-picture-content">
              <div style="display: flex;align-items: center;justify-content: space-between">
                <div >{{item.content}}</div>
                <div>{{ item.shootUser }} 摄</div>
              </div>
              <div>
                <span style="margin-right: 10px;">{{ item.shootTime }}</span>
                <span>{{ item.shootPlace }}</span>
              </div>
            </div>
            <div  class="detail-picture-img" v-for="(p, index) in item.pictureVideoFileList">
              <img style="z-index: 0" @click="imageClick(p)" :src="p.url" alt=""/>
            </div>
          </el-carousel-item>
        </el-carousel>
        <el-dialog fullscreen :visible.sync="dialogVisibleImg" width="100%"   v-if="showPreview" style="z-index: 9999 !important; height: 100vh!important; "  close-on-click-modal :modal="false" >
        <div v-if="currentImage" class="image-preview" style="height: 100%;">
          <div v-show="showPreview">
            <div @click="prevImage" style="position: fixed;left: 5%; top: 50vh;width: 40px;height: 40px; border-radius: 50%;background-color: rgba(0,0,0,0.2);">
              <i style="font-size: 18px;color: #fff;position:fixed;left: 5%; top: 50vh;cursor: pointer;margin-left: 9px;line-height: 40px" class="el-icon-arrow-left"></i>
            </div>
            <img :src="currentImage" style="position: fixed;top: 20px !important;" class="preview-image" />
            <div style="color: #fff; font-size: 16px;position: fixed;bottom: 20vh;left:50vw; transform: translate(-50%,0%);">{{currentContent}}</div>
            <div @click="nextImage" style="position: fixed;right: 5%; top: 50vh;width: 40px;height: 40px; border-radius: 50%;background-color: rgba(0,0,0,0.2);">
              <i style="font-size: 18px;color: #fff;position:fixed;right: 5%; top: 50vh;line-height: 40px;margin-right: 8px;cursor: pointer" class="el-icon-arrow-right"></i>
            </div>
          </div>
          <div class="thumbnail-list">
            <img v-for="(img, index) in selectedImage" :key="index" :src="img.url" alt="" @click="imageClick2(img.url,index)" />
          </div>
        </div>
        </el-dialog>
        -->
        <!-- 第一版本
        <el-carousel >
          <el-carousel-item v-for="item in swiperList" :key="item.id">
            <div class="detail-picture-content">
              <div style="display: flex;align-items: center;justify-content: space-between">
                  <div >{{item.content}}</div>
                <div>{{ item.shootUser }} 摄</div>
              </div>
              <div>
                <span style="margin-right: 10px;">{{ item.shootTime }}</span>
                <span>{{ item.shootPlace }}</span>
              </div>
            </div>
            <div  class="detail-picture-img" >
              <el-image :z-index="2000" v-for="(img,index) in selectedImage"
                        :src="img" @click="imageClick(item.url, index)"/>
            </div>
          </el-carousel-item>
        </el-carousel>
        <el-dialog title="图像预览"  :visible.sync="dialogVisibleImg" width="700" height="500px" style="z-index:0;">
          <viewer :class="[activeClass]" :images="selectedImage" style="display: flex">
            <img v-for="(src,index) in selectedImage" :src="src" :key="index" style="width: 100px; height: 100px; margin-left: 10px"/>
          </viewer>
        </el-dialog>
     -->

      </div>
      <div v-else>
        <el-empty description="暂无数据"></el-empty>
      </div>
    </div>

<!--    <p class="content" v-html="detailList.content"></p>-->
<!--    附件-->
    <div class="fileList" v-if="detailList.dynamicFileList">
     <div class="fileDynamicFileList" >
       <div v-for="(file,fileIndex) in detailList.dynamicFileList" :key="fileIndex"
            style="float:left;width: 100%;">
         <div @click="previewFile(file)" style="min-width: 100%">
           <div style="font-weight: 700;padding-left: 0;width: 100%;color: darkred;font-size: 18px">附件：</div>
             <el-divider></el-divider>
           <div class="link">
             <i class="el-icon-connection"></i>
             <span style="font-size: 16px">{{file.name}}</span>
           </div>
         </div>
       </div>
     </div>
    </div>
<!--    工作指南-->
    <div class="fileList" v-if="detailList.workGuideFileList">
      <div class="file" >
        <div v-for="(file,fileIndex) in detailList.workGuideFileList" :key="fileIndex"
             style="display: flex">
          <div @click="previewFile(file)" style="min-width: 100%">
            <div style="font-weight: 700;padding-left: 0;width: 100%;color: darkred;font-size: 16px">附件：</div>
            <el-divider></el-divider>
            <div class="link">
              <i class="el-icon-connection"></i>
              <span style="font-size: 14px">{{file.name}}</span>
            </div>
          </div>
        </div>

      </div>
    </div>
    <!--    pdf预览-->
    <el-dialog  :visible.sync="viewVisible" width="70%" center>
      <template>
        <iframe class="prism-player" :src="pdfUrl" width="100%" height="800px"></iframe>
      </template>
    </el-dialog>
    </div>
<!--    展示图片预览-->
    <div class="preview" style="" v-if="dialogVisibleImg">
      <span style="position: absolute;right: 32px;top: 16px;cursor: pointer" class="el-icon-close" @click="dialogVisibleImg = false"></span>
      <div @click="prevImage" style="position: fixed;left: 5%; top: 50vh;width: 40px;height: 40px; border-radius: 50%;background-color: rgba(0,0,0,0.2);">
        <i style="font-size: 18px;color: #fff;position:fixed;left: 5%; top: 50vh;cursor: pointer;margin-left: 9px;line-height: 40px" class="el-icon-arrow-left"></i>
      </div>
      <div class="preview-img" style="margin-top: 16px" >
        <img :src="selectedImage[this.currentImageIndex].url" alt="" id="image">
        <div class="preview-text" >
          <div style="color: white">{{ currentContent }}</div>
          <div style="color: white">{{ currentUser }} 摄</div>
        </div>
        <div class="preview-text-bottom" >
          <span>{{ currentTime }}</span>
          <span style="margin-left: 16px;">{{ currentPlace }}</span>
        </div>
        <div style="position: fixed;margin-left: 50%;  transform: translate(-50%,0%); text-align: center;width: 350px;height: 40px;border-radius: 20px;background-color: rgba(255,255,255,.2);">
          <span class="el-icon-plus"  style="margin: 0 20px;color: white;line-height: 40px" @click="zoomIn"></span>
          <span class="el-icon-minus"  style="margin: 0 20px;color: white;line-height: 40px" @click="zoomOut"></span>
          <span class="el-icon-full-screen"  style="margin: 0 20px;color: white;line-height: 40px" @click="fullScreenClick"></span>
        </div>
      </div>
      <div @click="nextImage" style="position: fixed;right: 5%; top: 50vh;width: 40px;height: 40px; border-radius: 50%;background-color: rgba(0,0,0,0.2);">
        <i style="font-size: 18px;color: #fff;position:fixed;right: 5%; top: 50vh;line-height: 40px;margin-right: 8px;cursor: pointer" class="el-icon-arrow-right"></i>
      </div>
      <div class="bottom-thumbnail-list" ref="container">
<!--        <div class="el-icon-arrow-left left" @click="moveLeft"></div>-->
        <div class="thumbnail-list">
          <img v-for="(img, index) in selectedImage" :key="index" :src="img.url" alt="" @click="imageClick2(img.url,index)" />
        </div>
<!--        <div class="el-icon-arrow-right right" @click="moveRight"></div>-->
      </div>
    </div>
  </div>
</template>

<script>
import otherNav from '@/components/navBar/otherNav'
// import videojs from 'video.js';
// import pdf from 'vue-pdf-signature'
import {getObjInformation, getObjProgressWork, getObjProblem, getObjRelationWe,getObjPicture,getObjvideo,
  getObjFieldData, getObjWorkguide, getObjHelpDocuments,getObjStandardSpecification } from "@/network/detailCom";
// import 'quill/dist/quill.snow.css'
// import { getFile } from '@/network/common'
// import {Base64} from "js-base64";
// import "videojs-contrib-hls"
import {getChildPictureList} from "@/network/scientificRearch/picturevideo";
import  myWaterfall from "@/components/waterfall/index.vue";
export default {
  name: "detail",
  components: { otherNav, myWaterfall },
  filters:{
    videoOption(val) {
      // console.log('val',val)
      return {
        playbackRates: [0.5,1.0,1.5,2.0],
        live: false,
        preload: "auto",
        autoplay: false,
        language: "zh-CN",
        aspectRatio: "16:9",
        fluid: true,
        sources: [
          {
            src: val //url地址
          }
        ],
        hls: true,
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, //当前时间和持续时间的分隔符
          durationDisplay: true, //显示持续时间
          remainingTimeDisplay: false, //是否显示剩余时间
          fullscreenToggle: true //全屏按钮
        },
        flash: {
          hls: {
            withCredentials: false
          }
        }
      }
    },
  },
  data() {
    return {
      scale: 1,
      step:0.2,
      currentImage: '',
      currentImageIndex: 0, // 当前预览图片的索引
      currentContent: '',
      currentUser: '',
      currentTime: '',
      currentPlace: '',
      col: 5,
      dialogVisibleImg: false,
      dialogVisible: false, //是否打开轮播大图的弹框
      selectedImage: null,
      //-------------------
      playsinline: true,
      playerOptions: {
        events: [],
        playbackRates: [0.7, 1.0, 1.5, 2.0], // 播放速度
        autoplay: true, // 如果true,浏览器准备好时开始回放。
        controls: true, //  控制条
        preload: 'auto', // 视频预加载
        muted: false, //  默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        language: 'zh-CN',
        controlBar: {
          timeDivider: true,
          durationDisplay: true
        },
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          type: 'application/x-mpegURL',
          src: ''
        }],
        hls: true, // 启用hls？
        poster: '', // 你的封面地址
        width: document.documentElement.clientWidth,
        notSupportedMessage: '此视频暂无法播放，请稍后再试' //  允许覆盖Video.js无法播放媒体源时显示的默认信息。
      },
      detailId: 0,
      detailList: {},
      formName:'',
      editorText: '',
      editorImg: [],
      posterPicList: [],
      posterPic: '',
      mapList: {},
      isControls: false,
      pdfUrl: '', // pdf绑定的url链接
      viewVisible: false,
      playVideo:{
        watchMaxTime: 0,
        copyCurrentTime: 0,

      },
      videoRealTime: 0,
      initialTime: '',
      myVideo: {},
      fileList:[],
      swiperList: [],

      // dialogVisibleImg: false,
      // currentImage: null,
      // isShowLittle: false,
      // activeClass: '',
      //
      // showPreview: false, // 控制大图预览显示
      // currentImageIndex: 0, // 当前预览图片的索引
      // fullscreenMode: true, // 全屏模式
      // currentContent: ''
    }
  },
  computed: {
    heightNum() {
      let num = 9*800/16
      // console.log(num)
      return num
    },
    currentImage() {
      return this.selectedImage[this.currentImageIndex].url;
    }
  },
  mounted() {

    this.detailId = this.$route.params.id
    this.formName = this.$route.params.formName
    this.getDetail()
    /*视频
    this.$nextTick(() => {
      this.getVideo()
    })
    */
  },
  methods: {

    moveLeft() {
      if (this.currentImageIndex > 0) {
        // console.log(111)
        this.currentImageIndex--;
        this.scrollToCurrentIndex();
      }
    },
    moveRight() {
      if (this.currentImageIndex < this.selectedImage.length - 1) {
        this.currentImageIndex++;
        this.scrollToCurrentIndex();
      }
    },
    scrollToCurrentIndex() {
      const container = this.$refs.container;
      const imageWidth = container.offsetWidth; // 获取每个图片的宽度
      const scrollLeft = imageWidth * this.currentImageIndex;
      container.scrollTo({
        left: scrollLeft,
        behavior: "smooth" // 可选，添加滚动动画
      });
    },
    /**
     * 放大
     */
    zoomIn() {
      this.scale += this.step;
      this.applyZoom();
    },
    /**
     * 缩小
     */
    zoomOut() {
      this.scale -= this.step;
      this.applyZoom();
    },

    applyZoom() {
      let image = document.getElementById('image');
      image.style.transform = 'scale(' + this.scale + ')';
    },
    /**
     * 全屏
     */
    fullScreenClick() {
      // 获取图片元素
      const image = document.getElementById('image');
// 进入全屏模式
      if (image.requestFullscreen) {
        image.requestFullscreen();
      } else if (image.mozRequestFullScreen) { // 兼容 Firefox
        image.mozRequestFullScreen();
      } else if (image.webkitRequestFullscreen) { // 兼容 Chrome, Safari 和 Opera
        image.webkitRequestFullscreen();
      } else if (image.msRequestFullscreen) { // 兼容 IE/Edge
        image.msRequestFullscreen();
      }
    },
    /**
     * 上一页
     */
    prevImage() {
      if (this.currentImageIndex > 0) {
        this.currentImageIndex--;
      }else {
        this.currentImageIndex = this.selectedImage.length-1

      }
      this.currentImage = this.selectedImage[this.currentImageIndex].url;
      this.currentContent = this.selectedImage[this.currentImageIndex].content
      this.currentTime = this.selectedImage[this.currentImageIndex].shootTime
      this.currentPlace = this.selectedImage[this.currentImageIndex].shootPlace
      this.currentUser = this.selectedImage[this.currentImageIndex].shootUser




    },
    /**
     * 下一页
     */
    nextImage() {
      if (this.currentImageIndex < this.selectedImage.length - 1) {
        this.currentImageIndex++;
      }else {
        this.currentImageIndex = 0
      }
      this.currentImage = this.selectedImage[this.currentImageIndex].url;
      this.currentContent = this.selectedImage[this.currentImageIndex].content
      this.currentTime = this.selectedImage[this.currentImageIndex].shootTime
      this.currentPlace = this.selectedImage[this.currentImageIndex].shootPlace
      this.currentUser = this.selectedImage[this.currentImageIndex].shootUser
    },
    /**
     * 点击图片放大图片
     * @param player
     */
    imgClick(item) {
      // console.log(item, this.data)
      /**
       * 点击图片放大图片
       * @param player
       */
      this.currentImage = item
      this.dialogVisibleImg = true;
      this.currentImageIndex = this.selectedImage.findIndex((i) => i.id === item.id);
      this.currentImage = this.selectedImage[this.currentImageIndex].url
      this.currentContent = this.selectedImage[this.currentImageIndex].content
      this.currentTime = this.selectedImage[this.currentImageIndex].shootTime
      this.currentPlace = this.selectedImage[this.currentImageIndex].shootPlace
      this.currentUser = this.selectedImage[this.currentImageIndex].shootUser
    },
    imageClick2(val,index) {
      // console.log('5675',index)
      this.currentImage = val
      this.currentImageIndex = index;
      this.currentContent = this.selectedImage[this.currentImageIndex].content
      this.currentTime = this.selectedImage[this.currentImageIndex].shootTime
      this.currentPlace = this.selectedImage[this.currentImageIndex].shootPlace
      this.currentUser = this.selectedImage[this.currentImageIndex].shootUser
      // console.log(this.currentImageIndex)
    },
    closeDialog(done) {
      this.dialogVisible = false;
      done();
    },

    // playReadied(player) {
    //   let hls = player.tech({ IWillNotUseThisInPlugins: true }).hls
    //   player.tech_.hls.xhr.beforeRequest =  (options) => {
    //     let token = localStorage.getItem('access_token')
    //     options.headers = {
    //       'Accept': 'application/json, text/plain, */*',
    //       'Content-Type': 'application/json;charset=UTF-8',
    //       'Accept-Language': 'zh-CN,zh;q=0.9,hy;q=0.8,mn;q=0.7',
    //       'Authorization': 'Bearer ' + token
    //     }
    //     return options
    //   }
    // },
    /*
        getVideo() {
      this.myVideo = videojs("myVideo",{
        bigPlayButton: true,
        textTrackDisplay: false,
        posterImage: false,
        errorDisplay: false,
        loop: true,
        autoplay: true,
        hls: {
          withCredentials: false,
        }
      },function onPlayerReady() {
        this.on("error", function () {
          // 播放过程中由于网络或其他原因产生的等待，此时视频播放暂停，等网络恢复后会自动执行【playing】自动播放
          //这里是只要报错就去执行重新请求直播流的函数
        });
      })
    },
    */
    /* 视频
    timeUpdate(e) {
      // console.log(e)
      let myVideo = this.$refs.my_video
      if(myVideo.currentTime > this.playVideo.watchMaxTime)
        var num = parseFloat(myVideo.currentTime) - parseFloat(
            this.playVideo.watchMaxTime
        )
      if(num < 1) {//正常播放，记录当前播放时间
        this.playVideo.watchMaxTime = myVideo.currentTime
        this.playVideo.copyCurrentTime = myVideo.currentTime

      } else { //大于1s，被拖动，奖上一次记录的时间赋值给当前播放器的播放时间
        myVideo.currentTime = this.playVideo.watchMaxTime
        this.playVideo.copyCurrentTime = this.playVideo.watchMaxTime
      }
    },
    */
    /*
    onPlay(val) {
      const video = document.getElementById('video')
      document.getElementById('poster').style.display = 'none'
        video.controls = true
        video.play()
    },
    */

    handleSelect(key, keyPath) {
      this.$router.push({path:key}).catch(err => {
        // console.log(err)
      })
    },
    getDetail() {
      if (this.formName == 'information') {
        getObjInformation(this.detailId).then(res => {
          this.detailList = res.data.data
          this.getEditorText(this.detailList.content)
          this.fn(this.detailList.content)
          this.imgHandle(this.detailList.content)
        })
      } else if (this.formName == 'progressWork') {
        getObjProgressWork(this.detailId).then(res => {
          this.detailList = res.data.data
          this.getEditorText(this.detailList.content)
          this.fn(this.detailList.content)
          this.imgHandle(this.detailList.content)
        })
      } else if (this.formName == 'problem') {
        getObjProblem(this.detailId).then(res => {
          this.detailList = res.data.data
          this.getEditorText(this.detailList.content)
          this.fn(this.detailList.content)
          this.imgHandle(this.detailList.content)

        })
      } else if (this.formName == 'relationWe') {
        getObjRelationWe(this.detailId).then(res => {
          this.detailList = res.data.data
          this.getEditorText(this.detailList.content)
          this.fn(this.detailList.content)
          this.imgHandle(this.detailList.content)
        })
      } else if (this.formName == 'picture') {
        getObjPicture(this.detailId).then(res => {
          // console.log('6457364',res)
          this.detailList = res.data.data
          // this.getEditorText(this.detailList.content)
          // this.fn(this.detailList.content)
          // this.imgHandle(this.detailList.content)
        })
        getChildPictureList(this.detailId, 'childPicture', 1,1000).then(res => {
          // console.log(res)
          if(res.data.code === 0) {
            this.swiperList = res.data.data.records
          }
          this.selectedImage = this.swiperList.map((item, i) => {
            // console.log('363',item)
            let obj = {
              id: item.pictureVideoFileList[0].id,
              url: item.pictureVideoFileList[0].url,
              content: this.swiperList[i].content,
              shootTime: item.shootTime,
              shootUser: item.shootUser,
              shootPlace: item.shootPlace

            }
            return obj
          })
          // console.log(this.selectedImage)
        })
      }else if (this.formName == 'video') {
        // getObjvideo(this.detailId).then(res => {
        //   this.detailList = res.data.data
        //   // this.getVideoFile(this.detailList.pictureVideoFileList)
        //   this.getEditorText(this.detailList.content)
        //   this.fn(this.detailList.content)
        //   this.imgHandle(this.detailList.content)
        //   for(let k in this.detailList.videoCoverList) {
        //     this.posterPic = this.detailList.videoCoverList[k].url
        //     // console.log('23456',this.posterPic)
        //   }
        // })
      }else if (this.formName == 'fieldData') {
        getObjFieldData(this.detailId).then(res => {
          this.detailList = res.data.data
          this.getEditorText(this.detailList.content)
          this.fn(this.detailList.content)
          this.imgHandle(this.detailList.content)
        })
      }else if (this.formName == 'collectManagement') {
        getObjWorkguide(this.detailId).then(res => {
          this.detailList = res.data.data
          this.getEditorText(this.detailList.content)
          this.fn(this.detailList.content)
          this.imgHandle(this.detailList.content)
        })
      }else if (this.formName == 'helpDocuments') {
        getObjHelpDocuments(this.detailId).then(res => {
          this.detailList = res.data.data
          this.getEditorText(this.detailList.content)
          this.fn(this.detailList.content)
          this.imgHandle(this.detailList.content)
        })
      }else if (this.formName == 'standardSpecification') {
        getObjStandardSpecification(this.detailId).then(res => {
          this.detailList = res.data.data
          this.getEditorText(this.detailList.content)
          this.fn(this.detailList.content)
          this.imgHandle(this.detailList.content)
        })
      }

    },
    previewFile(row) {
      // console.log(row)
      // let urlPdf = window.URL.createObjectURL(new Blob(row.url))
      this.pdfUrl = '/pdf/web/viewer.html?file=' + encodeURIComponent(row.url)
      this.viewVisible = true
      // console.log(row)
      // this.videoUrl =  'http://tdcloud-gateway:9999/admin/sys-file/' + row.bucketName + '/' + row.name
      // let url =this.$store.state.baseUrl + ':9999/admin/sys-file/' + row.bucketName + '/' + row.name
      // window.open(this.$store.state.baseUrl +':8012/onlinePreview?url=' + encodeURIComponent(Base64.encode(url)), '_blank')
    },
    imgHandle(val) {
      this.detailList.content = val.replace(/\<img/gi, '<img  style="margin:20px auto;display:block;max-width:55%; height:auto;"')
      // console.log(this.detailList.content)
    },
    getEditorText(str){
      this.editorText = str.replace(/<\/?(img|table)[^>]*>/g, "")
      return this.editorText
    },
    fn(str) {
      str.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/g, (match, capture) => {
        this.editorImg.push(capture)
      })
      return  this.editorImg
    },
    /*视频
    createPreImg(event) {
      const videoEle = event.target
      videoEle.currentTime = 1
      const canvas = document.createElement('canvas')
      videoEle.addEventListener('canplay', function () {
        const scale = 0.1
        canvas.width = videoEle.videoWidth * scale;
        canvas.height = videoEle.videoHeight * scale;
        canvas.getContext('2d').drawImage(videoEle, 0, 0, canvas.width, canvas.height);
        // 把canvas转成base64编码格式
        // 创建img元素 插入到文档中
        const imgSrc = canvas.toDataURL('image/png');
        const img = document.createElement('img');
        img.src = imgSrc;
        img.style.position = 'absolute';
        img.style.left = '0';
        img.style.top = '0';
        img.style.bottom = '0'
        img.style.width = '600px';
        img.style.height = '450px';
        img.style.zIndex = '-1';
        img.style.objectFit = 'cover';
        videoEle.parentNode && videoEle.parentNode.appendChild(img);
      })
    },
    */
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/css/detail";
::v-deep .el-carousel__indicators--horizontal {
  position: absolute !important;
  bottom: 50px !important;
}
::v-deep .el-carousel__indicators--outside button {
  background-color: #2A82E4 !important;
}
::v-deep .el-icon-arrow-right:before {
  font-size: 20px !important;
}
::v-deep .el-icon-arrow-left:before {
  font-size: 20px !important;
}
::v-deep .el-carousel__arrow{
  background-color: rgba(31,45,61,.3) !important;
}
.detail-picture{
  width: 100%;
  height: 0;
  position: relative;
  //padding-bottom: 56.25%;
  //padding-bottom: 25%;
}
::v-deep .el-carousel__container {
  width: 50%;
  height: 0;
  padding-bottom: 28.125%;
  margin: 0 auto;
  position: relative;
}

.detail-picture .detail-picture-img img{
  width: 100%;
  //height: 100vh;
  object-fit: cover;
}

::v-deep .el-dialog {
  background-color: rgba(0,0,0,.7);
  overflow-y: auto !important;
  position: fixed !important;
  //top: 0 !important;
  //height: 100vh !important;
}
::v-deep .el-icon-close:before {
  color: #fff;
  font-size: 24px;
}

.waterfall-container {
  background-color: #f8f8f8;
  width: 1200px;
  margin: 0 auto;
}

/**

 */
.item-body {
  margin: 9px;
  //height: 100vh;
  .item-desc {
    text-align: left;
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    color: #000000;
  }
  .item-footer {
    display: flex;
    justify-content: space-between;
    .footer-left {
      display: flex;
      align-items: center;
      font-family: SF Pro Display;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 14px;
      color: #333;
      margin: 16px 0;
      img {
        border-radius: 50%;
        width: 22px;
        height: 22px;
        margin-right: 4px;
      }
      .time {
        margin-right: 4px;
        font-size: 14px;
      }
      .name {
        font-size: 14px;
        color: #333;
      }
    }
    .like {
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: SF Pro Display;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 14px;
      color: #333;
      img{
        margin-right: 4px;
      }
    }
  }
}
.cell-item {
  width: 100%;
  margin-bottom: 6px;
  background: #ffffff;
  border: 2px solid #f0f0f0;
  border-radius: 6px;
  overflow: hidden;
  box-sizing: border-box;
  &:after{
    content: "";
    display: block;
    clear: both;
  }
  img {
    width: 100%;
    height: auto;
    display: block;
  }
}
.image-preview {
  position: absolute;
  text-align: center;
  z-index: 9999;
  width: 100vw;
  height: 100vh;
  .preview-image {
    position: fixed;
    top: 20px !important;
    margin-left: 50%;
    text-align: center;
    width: auto;
    height: 540px;
    transform: translate(-50%,0%);
    object-fit: contain;
    .preview-text{
      display: flex;
      justify-content: space-between;
      margin: 4px 16px;
      font-size: 16px
    }
    .preview-text-bottom {
      color: white;
      text-align: left;
      margin-left: 16px;
      font-size: 16px
    }
    img {
      width: 100%;
      height: 95%;
    }
  }
}
.image-preview img {
  width: 50%;
  //height: 50% * 3 / 4 !important;
  border-radius: 4px;
  border: 2px solid #fff;
  object-fit: cover;
}
.thumbnail-list {
  //width: 100vw;
  padding: 0 10px;
  overflow-x: auto;
  overflow-y: hidden;
  display: flex;
  text-align: left;
  position: absolute;
  bottom: 10vh;

}

.thumbnail-list img {
  width: 80px;
  height: 80px ;
  margin: 0 5px;
  transform: scale(1);
  transition: transform 3s ease 0s;

  &:hover {
    cursor: pointer;
    transform: scale(1.05);
  }
}
/**
开始预览
 */
.preview {
  position: absolute;
  top:0;
  z-index: 999;
  width: 100vw;
  height: 100%;
  background-color:rgba(0,0,0,.6);
  text-align: center;
  .preview-img {
    position: fixed;
    top: 16px !important;
    margin-left: 50%;
    //text-align: center;
    width: auto;
    height: 540px;
    transform: translate(-50%,0%);
    img {
      height: 100%;
      object-fit: contain;
      border-radius: 4px;
      border: 2px solid #fff;
    }
    .preview-text{
      display: flex;
      justify-content: space-between;
      margin: 4px 16px;
      font-size: 16px
    }
    .preview-text-bottom {
      color: white;
      text-align: left;
      margin-left: 16px;
      font-size: 16px
    }

  }
  .bottom-thumbnail-list {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 90px;
    position: fixed;
    bottom: 16px;
    left: 0;
    margin-bottom: 4px;
    .left, .right {
      color: white;
    }
    .left {
      margin-left: 16px;
    }
    .right {
      margin-right: 16px;
    }
    .thumbnail-list {
      margin: 0 32px;
      width: 95%;
      padding: 0 10px;
      overflow-x: auto;
      overflow-y: hidden;
      //display: flex;
      text-align: center;
      bottom: 16px;
      img {
        width: 80px;
        height: 80px ;
        margin: 0 5px;
        transform: scale(1);
        transition: transform 3s ease 0s;
        border-radius: 4px;
        border: 2px solid #fff;
        object-fit: cover;
        &:hover {
          cursor: pointer;
          transform: scale(1.05);
        }
      }
    }
  }


}
@media screen and (max-width: 1200px) {
  .waterfall-container {
    background-color: #f8f8f8;
    width: 100% !important;
    margin: 0 auto !important;
  }
}
</style>